import HttpClient from "../../../services/http-client";
import { IImportPurchaseItemResultResponse } from "../../../../model/scp/purchase-item-import/response/import-purchase-item-result-response";

const defaultPath = 'PurchaseItemImport';

const downloadTemplate = async (): Promise<Blob> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Template`,
        responseType: 'blob'
    }).then((response) => response.data);
};

const uploadFile = async (file: File): Promise<IImportPurchaseItemResultResponse> => {
    const formData = new FormData();
    formData.append('File', file);

    return await HttpClient.executeRequest({
        method: 'post',
        url: `/${defaultPath}/Upload`,
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }).then((response) => Object.assign({} as IImportPurchaseItemResultResponse, response.data));
};

const PurchaseItemImportAppService = {
    downloadTemplate,
    uploadFile
};

export default PurchaseItemImportAppService;
